import { render, staticRenderFns } from "./Certificaciones.vue?vue&type=template&id=1180e1af&scoped=true&"
import script from "./Certificaciones.vue?vue&type=script&lang=js&"
export * from "./Certificaciones.vue?vue&type=script&lang=js&"
import style0 from "./Certificaciones.vue?vue&type=style&index=0&id=1180e1af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1180e1af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
